/**
 * MYMUSE size guide: builds the "Μετρήσεις του ρούχου" table.
 * Source: the custom.size_measurements product metafield, one line per size,
 * e.g. "S: Στήθος 72, Μέση 68, Γοφός 82".
 */
(() => {
  const SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', 'ONE SIZE'];
  const COLUMNS = [
    ['bust', 'Στήθος'],
    ['waist', 'Μέση'],
    ['hips', 'Γοφός'],
    ['length', 'Μήκος'],
    ['inseam', 'Εσωτ. μήκος ποδιού'],
  ];
  const SIZE_RE = /^(XXS|XS|S|M|L|XL|XXL|3XL|ONE[\s-]?SIZE|S\/M|M\/L|XS\/S|L\/XL|3[4-9]|4[0-6])\b[\s:.-]*/i;
  const VALUE_RE =
    /([Α-Ωα-ωάέήίόύώϊϋΐΰ][Α-Ωα-ωάέήίόύώϊϋΐΰ .]{2,30}?)\s*:?\s*(\d{2,3})\s*(?:cm|εκ\.?)?|(\d{2,3})\s*(?:cm|εκ\.?)\s*([Α-Ωα-ωάέήίόύώϊϋΐΰ ]{3,30})/g;

  /** @param {string} label */
  const normalise = (label) => {
    const l = label.toLowerCase();
    if (/στήθ|στηθ|μπούστ/.test(l)) return 'bust';
    if (/καβάλ|καβαλ|εσωτ/.test(l)) return 'inseam';
    if (/μέσ|μεσ/.test(l)) return 'waist';
    if (/περιφ|γοφ|λεκάν/.test(l)) return 'hips';
    if (/μήκ|μηκ|ύψ|υψ/.test(l)) return 'length';
    return null;
  };

  /** @param {string} html */
  const toLines = (html) => {
    const box = document.createElement('div');
    box.innerHTML = html.replace(/<(p|h\d|li|br|div)[^>]*>/gi, '\n$&');
    return box.textContent.split(/\n+/).map((line) => line.trim()).filter(Boolean);
  };

  /** @param {string[]} lines */
  const parse = (lines) => {
    /** @type {Record<string, Record<string, number>>} */
    const table = {};
    let size = 'ONE SIZE';
    for (let line of lines) {
      const sizeMatch = line.match(SIZE_RE);
      if (sizeMatch) {
        size = sizeMatch[1].toUpperCase().replace(/ONE[\s-]?SIZE/, 'ONE SIZE');
        line = line.slice(sizeMatch[0].length);
      }
      for (const match of line.matchAll(VALUE_RE)) {
        const key = normalise(match[1] || match[4]);
        const value = Number(match[2] || match[3]);
        if (!key || value < 20 || value > 200) continue;
        (table[size] ??= {})[key] = value;
      }
    }
    return table;
  };

  /** @param {Record<string, Record<string, number>>} table */
  const render = (table) => {
    const sizes = Object.keys(table).sort((a, b) => {
      const ia = SIZE_ORDER.indexOf(a);
      const ib = SIZE_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b);
    });
    const columns = COLUMNS.filter(([key]) => sizes.some((s) => table[s][key]));
    if (!sizes.length || !columns.length) return null;

    const el = document.createElement('table');
    el.className = 'mm-size-guide__table';
    const head = columns.map(([, label]) => `<th scope="col">${label}</th>`).join('');
    const rows = sizes
      .map((s) => {
        const cells = columns.map(([key]) => `<td>${table[s][key] ?? '–'}</td>`).join('');
        return `<tr class="is-available"><th scope="row">${s === 'ONE SIZE' ? 'One Size' : s}</th>${cells}</tr>`;
      })
      .join('');
    el.innerHTML = `<thead><tr><th scope="col">Μέγεθος</th>${head}</tr></thead><tbody>${rows}</tbody>`;
    return el;
  };

  const init = () => {
    document.querySelectorAll('[data-mm-size-guide]').forEach((guide) => {
      if (guide.dataset.mmReady) return;
      guide.dataset.mmReady = 'true';

      const metafield = guide.querySelector('template[data-mm-measurements]')?.innerHTML.trim() ?? '';
      if (!metafield) return;

      const table = render(parse(toLines(metafield)));
      if (!table) return;
      guide.querySelector('[data-mm-garment-table]')?.append(table);
      guide.querySelector('[data-mm-garment]')?.removeAttribute('hidden');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
